import {motion} from 'motion/react'

import './Button.css'

export default function Button({ text, className, onClick}) {

    const handleOnclick = () =>{
        playSound()
        setTimeout(()=>{
            onClick()
        },500)
    }

   const playSound = () => {
        const audio = new Audio('/sounds/click2.mp3');
        audio.play().catch(error => console.log("Áudio bloqueado:", error));
    };

    return (
        <motion.button
            whileHover={{ scale: 1.08 }}
            className={`btn ${className}`}
            onClick={handleOnclick}
        >
            {text}
        </motion.button>
    );
}